import React, { useRef } from 'react';
import ColorConstants from 'constants/ColorConstants'
import DimensionsConstants from 'constants/DimensionsConstants'
import { IoIosGitMerge } from "react-icons/io"
import { IconContext } from "react-icons";
import CombineCodesOverlay from './CombineCodesOverlay'

const LARGE_BORDER_RADIUS = "5px"

const MergeDropZone = ({ 
  codeID, 
  showConfirmMerge, 
  showMerge, 
  container, 
  confirmMerge, 
  onHide,
  isOver // Now passed from parent
}) => {
  const targetRef = useRef(null);

  const dialogueShow = showConfirmMerge;
  const show = isOver || showMerge || dialogueShow;

  return (
    <div style={{
      width: "100%",
      height: DimensionsConstants.CODE_LABEL_HEIGHT * 2
    }}>
      {targetRef.current && <CombineCodesOverlay
        show={!!dialogueShow}
        container={container}
        target={targetRef.current}
        onClick={confirmMerge}
        onHide={onHide}
      />}
      <div 
        style={{
          width: DimensionsConstants.CODE_LABEL_HEIGHT,
          height: DimensionsConstants.CODE_LABEL_HEIGHT,
          backgroundColor: !!show ? ColorConstants.ULTRA_LIGHT_GREY : null,
          borderRadius: LARGE_BORDER_RADIUS,
          position: "relative",
        }}
        ref={targetRef}
      >
        {!!show &&
          <div>
            <div style={{
              position: "absolute",
              top: "8%",
              width: "100%",
              textAlign: "center"
            }}>
              <div style={{ margin: 0, padding: 0 }}>
                <IconContext.Provider value={{ 
                  color: ColorConstants.LIGHT_GREY, 
                  size: '1.25em', 
                  margin: 0, 
                  padding: 0 
                }}>
                  <IoIosGitMerge />
                </IconContext.Provider>
              </div>
            </div>
            <div style={{
              position: "absolute",
              bottom: "8%",
              width: "100%",
              textAlign: "center",
              color: ColorConstants.LIGHT_GREY
            }}>
              <div style={{ margin: 0, padding: 0 }}>
                <div style={{ margin: 0, padding: 0, fontSize: '0.6em' }}>
                  Merge
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default MergeDropZone;